module.exports = __webpack_public_path__ + "fce37dd5db98209ff04b0c83f1ac2638.MP3";